import Vue from 'vue'

import AlcoholInput from './AlcoholInput'
Vue.component('AlcoholInput',AlcoholInput)

import DecimalNumberInput from './DecimalNumberInput'
Vue.component('DecimalNumberInput',DecimalNumberInput)

import DatePicker from './DatePicker'
Vue.component('DatePicker',DatePicker)

import DurationPicker from './DurationPicker'
Vue.component('DurationPicker',DurationPicker)

import Search from './Search'
Vue.component('Search',Search)

import FilterSearch from './FilterSearch'
Vue.component('FilterSearch',FilterSearch)

import Breadcrumbs from './Breadcrumbs'
Vue.component('Breadcrumbs',Breadcrumbs)

import FilterMenu from './FilterMenu'
Vue.component('FilterMenu',FilterMenu)

import PicturePicker from './PicturePicker'
Vue.component('PicturePicker',PicturePicker)

import ConfirmLeave from './ConfirmLeave'
Vue.component('ConfirmLeave',ConfirmLeave)

import DeleteObject from './DeleteObject'
Vue.component('DeleteObject',DeleteObject)

import UpdateObjectFromAccounting from './UpdateObjectFromAccounting'
Vue.component('UpdateObjectFromAccounting',UpdateObjectFromAccounting)

import ExciseTransactions from './ExciseTransactions'
Vue.component('ExciseTransactions',ExciseTransactions)

import ImportCsv from './ImportCsv'
Vue.component('ImportCsv',ImportCsv)

import DateRange from './DateRange'
Vue.component('DateRange',DateRange)

import AccountPicker from './AccountPicker'
Vue.component('AccountPicker',AccountPicker)

import DashboardWidget from './DashboardWidget'
Vue.component('DashboardWidget',DashboardWidget)

import MultiLevelSelect from './MultiLevelSelect'
Vue.component('MultiLevelSelect',MultiLevelSelect)

import OutlinedBlock from './OutlinedBlock'
Vue.component('OutlinedBlock',OutlinedBlock)

import PopupHint from './PopupHint'
Vue.component('PopupHint',PopupHint)

import ListNotification from './ListNotification'
Vue.component('ListNotification',ListNotification)

import PurtrakTable from './PurtrakTable'
Vue.component('PurtrakTable',PurtrakTable)

import ScanCode from './ScanCode'
Vue.component('ScanCode',ScanCode)
